import { render, staticRenderFns } from "./ptPrivacy.vue?vue&type=template&id=0261b984&scoped=true&"
import script from "./ptPrivacy.vue?vue&type=script&lang=js&"
export * from "./ptPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./ptPrivacy.vue?vue&type=style&index=0&id=0261b984&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0261b984",
  null
  
)

export default component.exports